export const LOW_CREDITS_PERCENT = 15;
